import { useEffect, useState } from "react";

export function useShiftKeyPressed() {
  const [isShiftKeyPressed, setIsShiftKeyPressed] = useState(false);
  useEffect(() => {
    function kd(e: KeyboardEvent) {
      if (e.key === "Shift") setIsShiftKeyPressed(true);
    }
    function ku(e: KeyboardEvent) {
      if (e.key === "Shift") setIsShiftKeyPressed(false);
    }
    globalThis.addEventListener("keydown", kd);
    globalThis.addEventListener("keyup", ku);
    return () => {
      globalThis.removeEventListener("keydown", kd);
      globalThis.removeEventListener("keyup", ku);
    };
  });

  return isShiftKeyPressed;
}
